import React from "react";
import { styled } from "@mui/material/styles";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import RenderDate from "../../Common/Date/RenderDate";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: 12,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

function JobPlanObjectiveTable(props) {
    const objectives = props.objectives;

    return (
        <TableContainer>
            {objectives.length > 0 && (
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Objective</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Measurable</StyledTableCell>
                            <StyledTableCell align="center">By</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {objectives.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell>{row.details}</StyledTableCell>
                                <StyledTableCell>{row.type}</StyledTableCell>
                                <StyledTableCell>
                                    {row.measurable}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <RenderDate date={row.byDate} />
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </TableContainer>
    );
}

export default JobPlanObjectiveTable;
